import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchOrderData,
  getOrdersAuthData,
} from "businesslogic/dataStore/reducers/ordersAuth";
import { generateOtp } from "businesslogic/apis/ordersAuth";
import { isEmpty } from "lodash-es";

import Api from "../../utils/api";
import { getUrlParams } from "../../utils/validators";
import { navigate as navigateFunc } from "../../utils/functions";

import useErrorState from "../../common/customHooks/useErrorState";
import useLoadingState from "../../common/customHooks/useLoadingState";
import { ORDERS_AUTH_ROUTES } from "../../constants/ordersAuth";

import OrdersAuthLanding from "../../pages/OrdersAuth/OrderDetails/OrdersAuthLanding";
import ErrorScreen from "../../pages/OrdersAuth/ErrorScreen";

const screen = "ORDER_AUTH_DETAILS";

const ordersAuthContainer = (WrappedComponent) => (props) => {
  const navigate = navigateFunc.bind(props);
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const { isFetchFailed } = useErrorState(screen);
  const { isPageLoading } = useLoadingState(screen);
  const orderData = useSelector(getOrdersAuthData);

  const urlSafeKey = useMemo(
    () => getUrlParams()?.url_safekey,
    [props.location]
  );

  useEffect(() => {
    if (urlSafeKey) {
      dispatch(fetchOrderData({ Api, urlSafeKey, screen }));
    }
  }, [urlSafeKey]);

  const handleBackClick = useCallback(() => {
    window.close();
  }, []);

  const handleGenerateOtp = useCallback(async () => {
    setIsLoading(true);
    try {
      await generateOtp(Api, orderData.urlsafe_key);
      navigate(ORDERS_AUTH_ROUTES.OTP);
    } catch (error) {
      navigate(ORDERS_AUTH_ROUTES.ERROR);
    } finally {
      setIsLoading(false);
    }
  }, [orderData]);

  if (isFetchFailed || !urlSafeKey || isEmpty(orderData)) {
    return <ErrorScreen />;
  }

  return (
    <WrappedComponent
      isPageLoading={isPageLoading}
      orderData={orderData}
      handleBackClick={handleBackClick}
      handleGenerateOtp={handleGenerateOtp}
      isLoading={isLoading}
    />
  );
};

export default ordersAuthContainer(OrdersAuthLanding);
